import React, {useState} from 'react';
import RadarChart from 'react-svg-radar-chart';
import 'react-svg-radar-chart/build/css/index.css'
import classes from './index.css'
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
//example
/*
const data = [
    {
      data: {
        battery: 0.7,
        design: .8,
        useful: 0.9,
        speed: 0.67,
        weight: 0.8
      },
      meta: { color: 'blue' }
    },
    {
      data: {
        battery: 0.6,
        design: .85,
        useful: 0.5,
        speed: 0.6,
        weight: 0.7
      },
      meta: { color: 'red' }
    }
  ];

const captions = {
    // columns
    battery: 'Battery Capacity',
    design: 'Design',
    useful: 'Usefulness',
    speed: 'Speed',
    weight: 'Weight'
  };
*/
/*
<RadarChart
    captions={captions}
    data={data}
    size={450}
  />
*/

export default function WCRadarChart(props){
    const [dotVal, setDotVal] = useState(null);
    var data = props.data;
    var captions = props.captions;

    // console.log('wc radar chart data');
    // console.log(props);

    const noSmoothing = points => {
        let d = 'M' + points[0][0].toFixed(4) + ',' + points[0][1].toFixed(4);
        for (let i = 1; i < points.length; i++) {
          d += 'L' + points[i][0].toFixed(4) + ',' + points[i][1].toFixed(4);
        }
        return d + 'z';
      };

    const custOptions = {
        size: 200,
        axes: true, // show axes?
        scales: 1, // show scale circles?
        captions: true, // show captions?
        captionMargin: 10,
        dots: true, // show dots?
        zoomDistance: 1.2, // where on the axes are the captions?
        setViewBox: (options) => `-${options.captionMargin} 0 ${options.size + options.captionMargin * 2} ${options.size}`, // custom viewBox ?
        smoothing: noSmoothing, // shape smoothing function
        axisProps: () => ({ className: 'axis' }),
        scaleProps: () => ({ className: 'scale', fill: 'none' }),
        shapeProps: () => ({ className: 'shape' }),
        captionProps: () => ({
          className: 'caption',
          textAnchor: 'middle',
          fontSize: 10,
          fontFamily: 'sans-serif'
        }),
        dotProps: () => ({
          className: 'dot',
          mouseEnter: (dot) => { console.log(dot); setDotVal(dot.value * 100); /*can use this to display the value somewhere */},
          mouseLeave: (dot) => { setDotVal(null); }
        }),
        rotation: 0
      };


    const legend = () => {
        var keys= [];
        if(props.names){
            for(var i =0; i < props.data.length; i++){
                // console.log(props.data[i])
                if(props.data[i].meta){
                    keys.push(
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={2}>
                                <div style={{border: `1px solid ${props.data[i].meta.color}`,
                                    backgroundColor: props.data[i].meta.fill,
                                    height: '10px',
                                    width: '20px'}}>

                                </div>
                            </Grid>
                            <Grid item xs={10}>
                                {props.names[i]}
                            </Grid>
                        </Grid>
                    </Grid>);
                }
            }
        }
        return(
            <Grid container>
                    {keys.map((el) => {
                        return(<>{el}</>)
                    })}
            </Grid>
        )
    }

    // console.log(props);
    return(
        <div style={{width: '500px'}}>
            <div className={classes.radarChartContainer}>
                <RadarChart
                    captions={captions}
                    data={data}
                    size={500}
                    options={custOptions}
                />
            </div>
            {legend()}
        </div>
    )
}